import { ScheduleLifecyclePeriodLockedError } from "@common/schemas/domains/accounting/scheduleLifecycle.schema";
import { formatIsoDateForDisplay } from "@helpers/date";
import { joinWithAnd } from "@helpers/joinWithAnd";

export const SCHEDULE_LOCKED_PERIODS_TITLE = "Some periods are locked";
export const SCHEDULE_LOCKED_PERIODS_GO_TO_LOCKS_LABEL = "Go to locks";
export const SCHEDULE_LOCKED_PERIODS_CANCEL_LABEL = "Cancel";

/**
 * Names the blocked months rather than repeating the server's one-line
 * refusal, so the user knows which lock to move before trying again.
 */
export function buildScheduleLockedPeriodsBody({
    lockDate,
    lockedMonths,
}: Pick<
    ScheduleLifecyclePeriodLockedError,
    "lockDate" | "lockedMonths"
>): string {
    const affectedSentence =
        lockedMonths.length > 0
            ? `This change affects ${joinWithAnd(lockedMonths)}. `
            : "";
    return `Books are locked on or before ${formatIsoDateForDisplay(lockDate)}. ${affectedSentence}Unlock those periods and try again.`;
}
